import { requestApi } from "./axiosHelper"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const leadApi = rootUrl + "/lead"

export const createNewLead = async (obj) => {
  const axiosData = {
    url: leadApi,
    method: "post",
    data: obj,
  }
  const data = await requestApi(axiosData, true)

  return data
}

export const addNewNote = async (obj) => {
  const axiosData = {
    url: leadApi + "/",
    method: "put",
    data: obj,
  }
  const data = await requestApi(axiosData, true)

  return data
}

export const fetchLeads = async (obj) => {
  try {
    const axiosData = {
      url: obj?._id ? `${leadApi}/${obj?._id}` : `${leadApi}?${obj?.params}`,
      method: "get",
    }
    const data = await requestApi(axiosData, true)

    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const closeALead = async (_id) => {
  try {
    const axiosData = {
      url: `${leadApi}/close/${_id}`,
      method: "put",
    }
    const data = await requestApi(axiosData, true)

    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const deleteALead = async (_id) => {
  try {
    const axiosData = {
      url: `${leadApi}/${_id}`,
      method: "delete",
    }
    const data = await requestApi(axiosData, true)

    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const updateLead = async (obj) => {
  const { _id, ...rest } = obj

  try {
    const axiosData = {
      url: `${leadApi}/${_id}`,
      method: "patch",
      data: rest,
    }
    const data = await requestApi(axiosData, true)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}
